export const isIframed = (): boolean => {
    return typeof window == "undefined" ? false : window.location !== window.parent.location;
};
